export default "__VITE_PUBLIC_ASSET__1f64c499__"